import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RoleType } from 'src/enum/roletype';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { DivisionService } from 'src/app/services/division.service';
import { RegionService } from 'src/app/services/region.service';
import { ReportsService } from 'src/app/services/reports.service';
import { SubDivisionService } from 'src/app/services/subdivision.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { ShowtreasuryremittedreportComponent } from '../showtreasuryremittedreport/showtreasuryremittedreport.component';
import { DateTimeAdapter } from 'ng-pick-datetime';
import { AdministrativeMappingService } from "src/app/services/administrative-mapping.service";


@Component({
  selector: 'app-treasuryremittedreport',
  templateUrl: './treasuryremittedreport.component.html',
  styleUrls: ['./treasuryremittedreport.component.scss']
})
export class TreasuryremittedreportComponent implements OnInit {
  form: FormGroup;
  scheduledEndmin: any;
  scheduledEndmax: any;
  maxDate: Date;
  regionList: any[];
  subdivisionList: any[];
  divisionList: any[];
  filterregionList: any[];
  filterdivisionList: any[];
  filtersubdivisionList: any[];
  filterListsubdivisionList: any[];
  public RoleEnumType = RoleType;
  paymentList: any[];
  filterpaymentList: any[];
  roleId: number;
  currentDate: any;
  yearsList: any;
  filteryearsList: any[];
  monthsList: any;
  filtermonthsList: any[];
  financialYearList: any[] = [];

  constructor(private formBuilder: FormBuilder, private reportsService: ReportsService,
    public tripDialog: MatDialog,
    private regionService: RegionService,
    private divisionService: DivisionService,
    private subdivisionService: SubDivisionService,
    private userSessionService: UserSessionService,
    private httpClient: HttpClient,
    private administrativeMappingService: AdministrativeMappingService,

    dateTimeAdapter: DateTimeAdapter<any>) {
    dateTimeAdapter.setLocale('en-IN');
    this.regionList = [];
    this.yearsList = [];
    this.filteryearsList = [];
    this.filtermonthsList = [];
    this.monthsList = [];
    this.divisionList = [];
    this.subdivisionList = [];
    this.filterregionList = [];
    this.filterdivisionList = [];
    this.filtersubdivisionList = [];
    this.roleId = this.userSessionService.roleId();

  }

  ngOnInit(): void {

    this.currentDate = new Date();

    this.initializeValidators();
    this.getfinancialyear(true);
    this.maxDate = new Date();

    this.scheduledEndmax = moment(new Date()).format('YYYY-MM-DD');

    // this.getLookupRegion(true);
  }
  initializeValidators() {
    const startOfMonth = moment(new Date()).format('YYYY-MM-DD');
    this.currentDate = moment(new Date()).format('YYYY-MM-DD');
    this.form = this.formBuilder.group({
      ScheduledStart: [startOfMonth, Validators.required],
      ScheduledEnd: [this.currentDate, Validators.required],
      regionId: [null],
      divisionId: [null],
      subDivisionId: [null],
      // monthsId: ['', Validators.required],
      // yearId: ['', Validators.required],
      paymentId: [0]
    });
  }

  clearregionfilter() {
    this.filterregionList = this.regionList.slice();
  }



  getfinancialyear(refresh: boolean) {
    this.regionService.getFinYear(refresh).subscribe(result => {
      if (result) {
        this.financialYearList = result;
      }
      this.getLookupRegion(true);
    });
  }

  getFinYearIdByDate(date?: any) {
    const selectedDate = date ? moment(date) : moment();

    const matchedFinYear = this.financialYearList?.find(x => {
      const finYearStart = moment(`${x.startYear}-04-01`);
      const finYearEnd = moment(`${x.endYear}-03-31`);
      return selectedDate.isBetween(finYearStart, finYearEnd, 'day', '[]');
    });

    return matchedFinYear?.key ?? 0;
  }

  getLookupRegion(refresh: boolean) {
    const refDate = this.getFinYearIdByDate(this.form.value.ScheduledStart);
    this.administrativeMappingService.getRegions(refDate, refresh).subscribe(result => {

      //this.regionService.getLookUp(refresh).subscribe(result => {
      if (result) {
        this.regionList = [];
        this.filterregionList = [];
        this.regionList = result;
        this.filterregionList = this.regionList.slice();
        const regionLength = this.regionList.length;
        if (regionLength === 1) {
          this.form.controls['regionId'].setValue(this.regionList[0].key);
          this.getLookupDivision(this.form.value.regionId);
        }
      }
    })
  }
  regionChange() {
    this.getLookupDivision(this.form.value.regionId);
    this.form.controls['divisionId'].setValue(0);
    this.form.controls['subDivisionId'].setValue(0);
  }
  cleardivsionfilter() {
    this.filterdivisionList = this.divisionList.slice();
  }




  getLookupDivision(id) {
    const refDate = this.getFinYearIdByDate(this.form.value.ScheduledStart);
    this.administrativeMappingService.getDivisions(id, refDate, true).subscribe(result => {

      //this.divisionService.getLookUpbyId(true, id).subscribe(result => {
      if (result) {
        this.divisionList = [];
        this.filterdivisionList = [];
        this.divisionList = result;
        this.filterdivisionList = this.divisionList.slice();
        const divisionLength = this.divisionList.length;
        if (divisionLength === 1) {
          this.form.controls['divisionId'].setValue(this.divisionList[0].key);
          this.getLookupSubDivision(this.form.value.divisionId);
        }
      }
    })
  }
  divisionChange() {
    this.getLookupSubDivision(this.form.value.divisionId);
    this.form.controls['subDivisionId'].setValue(0);
  }

  clearsubdivsionfilter() {
    this.filterListsubdivisionList = this.subdivisionList.slice();
  }
  getLookupSubDivision(id) {
    const refDate = this.getFinYearIdByDate(this.form.value.ScheduledStart);
    this.administrativeMappingService.getSubDivisions(id, refDate, true).subscribe(result => {
      //this.subdivisionService.getLookUpbyId(true, id).subscribe(result => {
      if (result) {
        this.subdivisionList = [];
        this.filterListsubdivisionList = [];
        this.subdivisionList = result;
        this.filterListsubdivisionList = this.subdivisionList.slice();
        const subdivisionLength = this.subdivisionList?.length;
        if (subdivisionLength === 1) {
          this.form.controls['subDivisionId'].setValue(this.subdivisionList[0].key);
        }
      }
    })
  }
  setDate() {
    if (this.form.value.ScheduledEnd) {
      this.form.controls['ScheduledEnd'].setValue(null);
    }
    // const currDate = moment(new Date()).format('YYYY-MM-DD');
    // const yesterday = moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD');
    // const chooseDate = moment(this.form.value.ScheduledStart).format('YYYY-MM-DD');

    this.form.controls['regionId'].setValue(null);
    this.form.controls['divisionId'].setValue(null);
    this.form.controls['subDivisionId'].setValue(null);
    // const currDate = moment(new Date()).format('YYYY-MM-DD');
    // const yesterday = moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD');
    // const chooseDate = moment(this.form.value.ScheduledStart).format('YYYY-MM-DD');
    // const dcurr = moment(new Date(), "DD.MM.YYYY");
    // const dchoose = moment(this.form.value.ScheduledStart, "DD.MM.YYYY");
    // const datediff = dcurr.diff(dchoose, 'days');
    // if (datediff == 31 || datediff < 31) {
    //   if (dchoose <= dcurr || datediff < 31) {
    //     this.scheduledEndmax = moment(this.form.value.ScheduledStart).add(datediff, 'days').format('YYYY-MM-DD');
    //   } else {
    //     this.scheduledEndmax = moment(this.form.value.ScheduledStart).add(30, 'days').format('YYYY-MM-DD');
    //   }
    // } else if (datediff > 31) {
    //   if (this.form.value.ScheduledEnd)
    //     this.form.controls['ScheduledEnd'].setValue(null);
    //   this.scheduledEndmin = this.form.value.ScheduledStart;
    //   this.scheduledEndmax = moment(this.form.value.ScheduledStart).add(30, 'days').format('YYYY-MM-DD');
    // }
    this.scheduledEndmax = moment(new Date()).add(0, 'days').format('YYYY-MM-DD');
    this.getLookupRegion(true);
  }
  clear() {
    const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
    const today = moment(new Date()).format('YYYY-MM-DD');
    if (this.roleId === this.RoleEnumType.AssistantEngineer) {
      this.form.controls['ScheduledStart'].setValue(startOfMonth);
      this.form.controls['ScheduledEnd'].setValue(today);
    }
    if (this.roleId === this.RoleEnumType.AssistantExecutiveEngineer) {
      this.form.controls['ScheduledStart'].setValue(startOfMonth);
      this.form.controls['ScheduledEnd'].setValue(today);
    }
    if (this.roleId === this.RoleEnumType.ExecutiveEngineer) {
      this.form.controls['ScheduledStart'].setValue(startOfMonth);
      this.form.controls['ScheduledEnd'].setValue(today);
      this.form.controls['subDivisionId'].setValue(null);
    }
    if (this.roleId === this.RoleEnumType.SuperintendEngineer) {
      this.form.controls['ScheduledStart'].setValue(startOfMonth);
      this.form.controls['ScheduledEnd'].setValue(today);
      this.form.controls['divisionId'].setValue(null);
      this.form.controls['subDivisionId'].setValue(null);
    }
    if (this.roleId === this.RoleEnumType.Foreman) {
      this.form.controls['ScheduledStart'].setValue(startOfMonth);
      this.form.controls['ScheduledEnd'].setValue(today);
    }
    if (this.roleId === this.RoleEnumType.SuperAdmin ||
      this.roleId === this.RoleEnumType.ChiefEngineer ||
      this.roleId === this.RoleEnumType.SeniorEngineer ||
      this.roleId === this.RoleEnumType.Root) {
      this.initializeValidators();
    }
    this.scheduledEndmax = moment(new Date()).format('YYYY-MM-DD');
    this.regionList = [];
    this.divisionList = [];
    this.subdivisionList = [];
    this.filterdivisionList = [];

    this.filterListsubdivisionList = [];

    this.form.controls['regionId'].setValue(0);
    this.form.controls['divisionId'].setValue(0);
    this.form.controls['subDivisionId'].setValue(0);

    this.getLookupRegion(true);
  }
  showReport() {
    if (this.form.valid) {

      if (this.form.value.regionId == null) {
        this.form.controls['regionId'].setValue(0);
      }
      if (this.form.value.divisionId == null) {
        this.form.controls['divisionId'].setValue(0);
      }
      if (this.form.value.subDivisionId == null) {
        this.form.controls['subDivisionId'].setValue(0);
      }
      let startDate = this.form.get('ScheduledStart').value;
      let endDate = this.form.get('ScheduledEnd').value;
      startDate = moment(startDate).format('YYYY-MM-DD');
      endDate = moment(endDate).format('YYYY-MM-DD');
      const data = {
        startTs: startDate,
        endTs: endDate,
        divisionId: this.form.value.divisionId,
        regionId: this.form.value.regionId,
        subDivisionId: this.form.value.subDivisionId,
        ReportType: 11,
        paymentId: this.form.value.paymentId
      }
      const dialogRef = this.tripDialog.open(ShowtreasuryremittedreportComponent, {
        autoFocus: false,
        disableClose: true,
        width: '100%',
        height: '90%',
        panelClass: 'mat-dialog-bookingreport',
        data
      })
      dialogRef.afterClosed().subscribe(() => {
      });
    } else {
      this.validateFormControl();
    }
  }
  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }


}
